/**
 * Subscribe & Save popover – show on trigger click, close on toggle / CTA / outside / Escape.
 * Load from theme layout so it runs when cart content is injected.
 */
(function() {
  if (window.__subscribePopoverCartInitialized) return;
  window.__subscribePopoverCartInitialized = true;

  var BOUND = 'data-subscribe-popover-bound';

  (function ensureLoadingStyles() {
    if (document.getElementById('subscribe-popover-cart-loading-styles')) return;
    var style = document.createElement('style');
    style.id = 'subscribe-popover-cart-loading-styles';
    style.textContent = [
      '.popover-subscribe-btn--loading { pointer-events: none; }',
      '.popover-subscribe-btn__spinner { display: inline-block; width: 1em; height: 1em; border: 2px solid currentColor; border-right-color: transparent; border-radius: 50%; vertical-align: middle; margin-right: 0.5em; animation: subscribe-popover-spin 0.7s linear infinite; }',
      '@keyframes subscribe-popover-spin { to { transform: rotate(360deg); } }'
    ].join('\n');
    document.head.appendChild(style);
  })();

  function closePopover(popover) {
    if (!popover) return;
    popover.removeAttribute('data-subscribe-open');
    popover.style.removeProperty('display');
    popover.style.removeProperty('opacity');
    popover.style.removeProperty('visibility');
    popover.style.removeProperty('pointer-events');
    popover.style.removeProperty('position');
    popover.style.removeProperty('z-index');
    popover.style.removeProperty('max-height');
    popover.style.removeProperty('overflow-y');
    popover.style.left = '';
    popover.style.top = '';
    popover.style.width = '';
    popover.style.transform = '';
  }

  function closeAllOpen() {
    document.querySelectorAll('.subscribe-popover[data-subscribe-open]').forEach(closePopover);
  }

  function openPopoverForButton(button) {
    var container = button.closest('.subscription-upgrade-container');
    if (!container) return;
    var livePopover = container.querySelector('.subscribe-popover');
    if (!livePopover) return;

    livePopover.style.setProperty('display', 'block', 'important');
    livePopover.style.setProperty('opacity', '1', 'important');
    livePopover.style.setProperty('visibility', 'visible', 'important');
    livePopover.style.setProperty('pointer-events', 'auto', 'important');
    livePopover.style.setProperty('position', 'fixed', 'important');
    livePopover.style.setProperty('z-index', '999999', 'important');
    livePopover.style.setProperty('max-height', '90vh', 'important');
    livePopover.style.setProperty('overflow-y', 'auto', 'important');

    var btnRect = button.getBoundingClientRect();
    var isMobile = window.innerWidth <= 768;
    var popoverW = isMobile
      ? Math.min(300, window.innerWidth - 24)
      : Math.min(320, Math.max(200, window.innerWidth * 0.9));
    var anchor = container.closest('dialog') || container.closest('cart-drawer-component') || document.body;
    var anchorRect = anchor.getBoundingClientRect();
    var top = (btnRect.top - anchorRect.top) + btnRect.height + 8;
    top = Math.max(0, Math.min(top, anchorRect.height - 100));

    if (isMobile) {
      livePopover.style.left = '50%';
      livePopover.style.setProperty('transform', 'translateX(-50%)', 'important');
    } else {
      var left = (btnRect.left - anchorRect.left) + (btnRect.width / 2) - (popoverW / 2);
      left = Math.max(0, Math.min(left, anchorRect.width - popoverW));
      livePopover.style.left = left + 'px';
      livePopover.style.removeProperty('transform');
    }
    livePopover.style.top = top + 'px';
    livePopover.style.width = popoverW + 'px';
    livePopover.setAttribute('data-subscribe-open', '1');
  }

  function bindButton(button) {
    if (button.getAttribute(BOUND)) return;
    button.setAttribute(BOUND, '1');
    var container = button.closest('.subscription-upgrade-container');
    if (!container) return;
    var popover = container.querySelector('.subscribe-popover');
    if (!popover) return;

    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openPopoverForButton(button);
    });
  }

  var SUBSCRIPTION_SELLING_PLAN_ID = 690676990294;
  var MULTI_SUBSCRIPTION_SELLING_PLAN_ID = 690718572886;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '';
  var invalidPlanByVariant = {};
  var isReconcilingPlans = false;
  /** >0 while subscription lines are being removed/re-added for selling-plan normalization. */
  var planMutationDepth = 0;
  /** True while checkout must stay disabled until 10%/15% plan reconcile finishes. */
  var subscriptionCheckoutLock = false;
  var checkoutUnlockPollTimer = null;
  var reconcileRetryTimer = null;

  var INTERNAL_CART_UPDATE_SOURCES = {
    'subscribe-popover-plan-reconcile': true,
    'subscribe-popover-cart': true
  };

  function isInternalCartUpdateSource(source) {
    return !!(source && INTERNAL_CART_UPDATE_SOURCES[source]);
  }

  function isCartMutationBusy() {
    return planMutationDepth > 0 || isReconcilingPlans;
  }

  function getCheckoutButtons() {
    return document.querySelectorAll('#checkout, .cart__checkout-button, button[name="checkout"]');
  }

  function getAcceleratedCheckoutContainers() {
    return document.querySelectorAll(
      '.additional-checkout-buttons, shopify-accelerated-checkout-cart, [additional-checkout-buttons]'
    );
  }

  function applyCheckoutLockedUi(locked) {
    getCheckoutButtons().forEach(function(btn) {
      if (locked) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.setAttribute('data-subscription-checkout-locked', '1');
      } else if (btn.getAttribute('data-subscription-checkout-locked') === '1') {
        btn.removeAttribute('data-subscription-checkout-locked');
        btn.removeAttribute('aria-busy');
        var bubble = document.querySelector('.cart-bubble__text-count');
        var count = bubble ? parseInt((bubble.textContent || '').trim(), 10) : NaN;
        btn.disabled = !isNaN(count) && count <= 0;
      }
    });
    getAcceleratedCheckoutContainers().forEach(function(el) {
      if (locked) {
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.5';
        el.setAttribute('aria-disabled', 'true');
        el.setAttribute('data-subscription-checkout-locked', '1');
      } else if (el.getAttribute('data-subscription-checkout-locked') === '1') {
        el.style.pointerEvents = '';
        el.style.opacity = '';
        el.removeAttribute('aria-disabled');
        el.removeAttribute('data-subscription-checkout-locked');
      }
    });
  }

  function lockCheckoutForSubscriptionUpdate() {
    subscriptionCheckoutLock = true;
    window.__subscriptionCheckoutLocked = true;
    applyCheckoutLockedUi(true);
    scheduleCheckoutUnlockPoll();
  }

  function refreshCheckoutLockUi() {
    if (subscriptionCheckoutLock || isCartMutationBusy()) {
      applyCheckoutLockedUi(true);
    }
  }

  function scheduleCheckoutUnlockPoll() {
    if (checkoutUnlockPollTimer) return;
    checkoutUnlockPollTimer = setTimeout(function() {
      checkoutUnlockPollTimer = null;
      if (!subscriptionCheckoutLock && !isCartMutationBusy()) return;
      tryUnlockCheckoutForSubscriptionUpdate();
    }, 280);
  }

  function tryUnlockCheckoutForSubscriptionUpdate() {
    if (isCartMutationBusy() || reconcileRetryTimer) {
      scheduleCheckoutUnlockPoll();
      return;
    }
    cartFetch()
      .then(function(cart) {
        if (isCartMutationBusy() || reconcileRetryTimer) {
          scheduleCheckoutUnlockPoll();
          return;
        }
        if (cart && needsPlanNormalization(cart)) {
          lockCheckoutForSubscriptionUpdate();
          reconcilePlansFromCartState(function() {
            scheduleCheckoutUnlockPoll();
          });
          return;
        }
        subscriptionCheckoutLock = false;
        window.__subscriptionCheckoutLocked = false;
        applyCheckoutLockedUi(false);
      })
      .catch(function() {
        scheduleCheckoutUnlockPoll();
      });
  }

  function isSubscriptionCheckoutBlocked() {
    return (
      subscriptionCheckoutLock ||
      window.__subscriptionCheckoutLocked === true ||
      isCartMutationBusy()
    );
  }

  function bindCheckoutSubmitGuard() {
    if (bindCheckoutSubmitGuard._done) return;
    bindCheckoutSubmitGuard._done = true;
    document.addEventListener(
      'submit',
      function(e) {
        if (!isSubscriptionCheckoutBlocked()) return;
        var form = e.target;
        if (!form || form.tagName !== 'FORM') return;
        var formId = form.id || '';
        var action = (form.getAttribute('action') || '').toLowerCase();
        var isCartCheckout =
          formId === 'cart-form' ||
          form.querySelector('#checkout, .cart__checkout-button, button[name="checkout"]') ||
          (action.indexOf('/cart') !== -1 && form.querySelector('button[name="checkout"]'));
        if (!isCartCheckout) return;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );
    document.addEventListener(
      'click',
      function(e) {
        if (!isSubscriptionCheckoutBlocked()) return;
        var btn = e.target && e.target.closest
          ? e.target.closest('#checkout, .cart__checkout-button, button[name="checkout"]')
          : null;
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      },
      true
    );
  }

  function cartFetch() {
    return fetch(root + 'cart.js?' + Date.now(), { cache: 'no-store' }).then(function(r) { return r.json(); });
  }

  function addSubscriptionLine(variantId, qty, sellingPlanId) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: qty,
        selling_plan: sellingPlanId
      })
    }).then(function(r) {
      return r.json().then(function(data) {
        return { ok: r.ok, data: data };
      });
    });
  }

  function addSubscriptionLineWithFallback(variantId, qty, preferredPlanId, fallbackPlanId) {
    var preferred = parseInt(preferredPlanId, 10);
    var fallback = fallbackPlanId ? parseInt(fallbackPlanId, 10) : null;
    var variant = parseInt(variantId, 10);
    var invalidKey = String(variant) + ':' + String(preferred);

    // If this variant+plan already failed once, skip directly to fallback.
    if (invalidPlanByVariant[invalidKey]) {
      if (fallback && fallback !== preferred) {
        return addSubscriptionLine(variant, qty, fallback);
      }
      return Promise.resolve({ ok: false, data: { description: 'Preferred selling plan is invalid for this variant' } });
    }

    return addSubscriptionLine(variant, qty, preferred).then(function(result) {
      if (result.ok) return result;

      // Mark as invalid to avoid repeated 422 attempts in normalization flow.
      invalidPlanByVariant[invalidKey] = true;

      // Fallback to line-specific plan if preferred plan is rejected by Shopify (422).
      if (fallback && fallback !== preferred) {
        return addSubscriptionLine(variant, qty, fallback);
      }
      return result;
    });
  }

  function replaceSubscriptionLinePlan(lineItem, targetSellingPlanId) {
    var qty = Math.max(1, parseInt(lineItem.quantity, 10) || 1);
    var variantId = parseInt(lineItem.variant_id, 10);
    var fallbackPlanId = lineItem.selling_plan_allocation && lineItem.selling_plan_allocation.selling_plan
      ? parseInt(lineItem.selling_plan_allocation.selling_plan.id, 10)
      : null;
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: String(lineItem.key), quantity: 0 })
    })
      .then(function(r) {
        return r.json().then(function(data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Could not remove subscription line');
          return data;
        });
      })
      .then(function() { return new Promise(function(go) { setTimeout(go, 120); }); })
      .then(function() {
        return addSubscriptionLineWithFallback(variantId, qty, targetSellingPlanId, fallbackPlanId).then(function(result) {
          if (!result.ok) throw new Error((result.data && (result.data.description || result.data.message)) || 'Could not add subscription line');
          return result.data;
        });
      });
  }

  function getTargetPlanForCart(cart) {
    var subscriptionLines = (cart && cart.items ? cart.items : []).filter(function(i) {
      return i && i.selling_plan_allocation != null;
    });
    if (!subscriptionLines.length) return null;
    var totalSubscriptionQty = subscriptionLines.reduce(function(sum, line) {
      return sum + (parseInt(line.quantity, 10) || 0);
    }, 0);
    return totalSubscriptionQty >= 2
      ? MULTI_SUBSCRIPTION_SELLING_PLAN_ID
      : SUBSCRIPTION_SELLING_PLAN_ID;
  }

  function needsPlanNormalization(cart) {
    var targetSellingPlanId = getTargetPlanForCart(cart);
    if (!targetSellingPlanId) return false;
    var subscriptionLines = (cart && cart.items ? cart.items : []).filter(function(i) {
      return i && i.selling_plan_allocation != null;
    });
    return subscriptionLines.some(function(line) {
      var currentPlanId = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan
        ? parseInt(line.selling_plan_allocation.selling_plan.id, 10)
        : null;
      return currentPlanId !== targetSellingPlanId;
    });
  }

  function normalizeSubscriptionPlans(cart) {
    var subscriptionLines = (cart && cart.items ? cart.items : []).filter(function(i) {
      return i && i.selling_plan_allocation != null;
    });
    if (!subscriptionLines.length) return Promise.resolve(cart);

    var targetSellingPlanId = getTargetPlanForCart(cart);

    var needsUpdate = subscriptionLines.some(function(line) {
      var currentPlanId = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan
        ? parseInt(line.selling_plan_allocation.selling_plan.id, 10)
        : null;
      return currentPlanId !== targetSellingPlanId;
    });

    if (!needsUpdate) return Promise.resolve(cart);

    planMutationDepth++;
    var queue = Promise.resolve();
    subscriptionLines.forEach(function(line) {
      queue = queue.then(function() {
        var currentPlanId = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan
          ? parseInt(line.selling_plan_allocation.selling_plan.id, 10)
          : null;
        if (currentPlanId === targetSellingPlanId) return;
        return replaceSubscriptionLinePlan(line, targetSellingPlanId);
      });
    });

    return queue
      .then(function() { return cartFetch(); })
      .finally(function() {
        planMutationDepth--;
      });
  }

  function reconcilePlansFromCartState(done) {
    if (isReconcilingPlans) {
      setTimeout(function() {
        reconcilePlansFromCartState(done);
      }, 220);
      return;
    }
    if (isCartMutationBusy()) {
      setTimeout(function() {
        reconcilePlansFromCartState(done);
      }, 220);
      return;
    }
    isReconcilingPlans = true;
    lockCheckoutForSubscriptionUpdate();
    cartFetch()
      .then(function(cart) {
        if (!cart || !needsPlanNormalization(cart)) return null;
        return normalizeSubscriptionPlans(cart).then(function(finalCart) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: finalCart || null,
              data: { source: 'subscribe-popover-plan-reconcile' }
            }
          }));
          return finalCart;
        });
      })
      .catch(function() {})
      .then(function() {
        isReconcilingPlans = false;
        if (typeof done === 'function') done();
        tryUnlockCheckoutForSubscriptionUpdate();
      });
  }

  function convertToSubscription(btn, popover) {
    var variantId = btn.getAttribute('data-variant-id');
    var itemKey = (btn.getAttribute('data-item-key') || '').trim();
    var planFromButton = btn.getAttribute('data-selling-plan-id');
    var sellingPlanId = planFromButton ? parseInt(planFromButton, 10) : SUBSCRIPTION_SELLING_PLAN_ID;
    if (!variantId || !itemKey) return;

    var originalContent = btn.innerHTML;
    var loadingLabel = (btn.getAttribute('data-loading-label') || 'Suscribiendo...').trim();
    btn.disabled = true;
    btn.classList.add('popover-subscribe-btn--loading');
    btn.innerHTML = '<span class="popover-subscribe-btn__spinner" aria-hidden="true"></span><span class="popover-subscribe-btn__loading-text">' + loadingLabel + '</span>';
    lockCheckoutForSubscriptionUpdate();

    cartFetch()
      .then(function(cart) {
        var items = cart.items || [];
        var item = items.find(function(i) { return i.key === itemKey; });
        if (!item) {
          throw new Error('Item not found in cart. Please refresh and try again.');
        }
        var keyFromCart = item.key;
        var qty = Math.max(1, parseInt(item.quantity, 10) || 1);
        function removeLineByKey(key) {
          return fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: String(key), quantity: 0 })
          }).then(function(r) {
            return r.json().then(function(data) {
              if (!r.ok) throw new Error(data.description || data.message || 'Could not remove item ('.concat(r.status, ')'));
              return data;
            });
          });
        }
        return removeLineByKey(keyFromCart)
          .then(function() { return new Promise(function(go) { setTimeout(go, 150); }); })
          .then(cartFetch)
          .then(function(cartAfterRemove) {
            var stillThere = (cartAfterRemove.items || []).find(function(i) { return i.key === itemKey || i.key === keyFromCart; });
            if (stillThere) {
              return removeLineByKey(stillThere.key)
                .then(function() { return new Promise(function(go) { setTimeout(go, 150); }); })
                .then(cartFetch);
            }
            return cartAfterRemove;
          })
          .then(function(cartBeforeAdd) {
            var oneTimeStillThere = (cartBeforeAdd.items || []).some(function(i) { return i.key === itemKey; });
            if (oneTimeStillThere) {
              throw new Error('Could not remove one-time item. Please try again.');
            }

            // Plan selection rule:
            // - total subscription quantity < 2 => 10% plan
            // - total subscription quantity >= 2 (including qty=2 of same product) => 15% plan
            var existingSubscriptionQty = (cartBeforeAdd.items || []).reduce(function(sum, i) {
              if (!i || i.selling_plan_allocation == null) return sum;
              return sum + (parseInt(i.quantity, 10) || 0);
            }, 0);
            var resultingSubscriptionQty = existingSubscriptionQty + qty;
            sellingPlanId = resultingSubscriptionQty >= 2
              ? MULTI_SUBSCRIPTION_SELLING_PLAN_ID
              : SUBSCRIPTION_SELLING_PLAN_ID;

            return addSubscriptionLineWithFallback(variantId, qty, sellingPlanId, planFromButton);
          })
          .then(function(result) {
            if (!result.ok && result.data && result.data.description) {
              throw new Error(result.data.description);
            }
            if (result.data && result.data.status === 422) {
              throw new Error(result.data.description || 'Could not add subscription');
            }
            closePopover(popover);
            return cartFetch();
          })
          .then(function(updatedCart) {
            var variantIdNum = parseInt(variantId, 10);
            var lineWeAdded = (updatedCart.items || []).find(function(i) {
              return i.selling_plan_allocation != null && i.variant_id === variantIdNum;
            });
            if (lineWeAdded && lineWeAdded.quantity > qty) {
              return fetch(root + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: lineWeAdded.key, quantity: qty })
              }).then(function(r) { return r.ok ? r.json() : updatedCart; }).then(function(c) { return c || updatedCart; });
            }
            return updatedCart;
          })
          .then(function(cartAfterQtyFix) {
            return normalizeSubscriptionPlans(cartAfterQtyFix);
          })
          .then(function(finalCart) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: finalCart || null,
                data: { source: 'subscribe-popover-cart' }
              }
            }));
          });
      })
      .catch(function() {})
      .then(function() {
        btn.disabled = false;
        btn.classList.remove('popover-subscribe-btn--loading');
        btn.innerHTML = originalContent;
        tryUnlockCheckoutForSubscriptionUpdate();
      });
  }

  function bindPopoverCta(popover) {
    var btn = popover.querySelector('.popover-subscribe-btn');
    if (!btn || btn.getAttribute(BOUND)) return;
    btn.setAttribute(BOUND, '1');
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var itemKey = btn.getAttribute('data-item-key');
      var variantId = btn.getAttribute('data-variant-id');
      if (itemKey && variantId) {
        convertToSubscription(btn, popover);
      } else {
        closePopover(popover);
      }
    });
  }

  function onDocumentClick(e) {
    var triggerBtn = e.target.closest('.subscribe-upgrade-btn');
    if (triggerBtn) {
      e.preventDefault();
      e.stopPropagation();
      openPopoverForButton(triggerBtn);
      return;
    }

    var ctaBtn = e.target.closest('.popover-subscribe-btn');
    if (ctaBtn) {
      e.preventDefault();
      e.stopPropagation();
      var popover = ctaBtn.closest('.subscribe-popover');
      var itemKey = ctaBtn.getAttribute('data-item-key');
      var variantId = ctaBtn.getAttribute('data-variant-id');
      if (itemKey && variantId) {
        convertToSubscription(ctaBtn, popover);
      } else if (popover) {
        closePopover(popover);
      }
      return;
    }

    if (e.target.closest('.subscribe-popover')) return;
    closeAllOpen();
  }

  function init() {
    document.querySelectorAll('.subscribe-upgrade-btn').forEach(bindButton);
    document.querySelectorAll('.subscribe-popover').forEach(bindPopoverCta);
  }

  document.addEventListener('click', onDocumentClick, true);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeAllOpen();
  });

  bindCheckoutSubmitGuard();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 500);
  setTimeout(init, 1500);
  setTimeout(init, 3000);
  document.addEventListener('cart:update', function(e) {
    setTimeout(init, 100);
    setTimeout(refreshCheckoutLockUi, 50);
    setTimeout(refreshCheckoutLockUi, 300);
    var src = e.detail && e.detail.data && e.detail.data.source;
    if (isInternalCartUpdateSource(src)) return;
    lockCheckoutForSubscriptionUpdate();
    setTimeout(function() {
      reconcilePlansFromCartState(function() {
        tryUnlockCheckoutForSubscriptionUpdate();
      });
    }, 180);
  });
})();
